import id from './id'

const user = {
  field: 'user',
  type: 'm2o',
  datatype: 'int',
  interface: 'many-to-one',
  length: 100,
  options: {
    template: '{{last_name}} {{first_name}}',
    visible_fields: 'last_name,first_name'
  }
}

const now = {
  field: 'now',
  type: 'm2o',
  datatype: 'int',
  interface: 'many-to-one',
  length: 100,
  options: {
    template: '{{value}}',
    visible_fields: 'value'
  }
}

const memo = {
  field: 'memo',
  type: 'string',
  datatype: 'varchar',
  interface: 'textarea',
  length: 200
}

export default {
  collection: 'member_seating_status',
  note: 'メンバーの在席状況です。',
  fields: [
    id,
    user,
    now,
    memo
  ]
}
